import { gql } from "@apollo/client";

export const GET_COMPANY_NOTIFICATION_PREFERENCES = gql`
  query getCompanyNotificationPreferences {
    getCompanyNotificationPreferences {
      template_key
      channel_key
      channel_title
      cadence_key
      enabled
      cadence_editable
    }
  }
`;

export const GET_MY_NOTIFICATION_PREFERENCES = gql`
  query getMyNotificationPreferences {
    getMyNotificationPreferences {
      template_key
      channel_key
      channel_title
      cadence_key
      enabled
      is_locked
      cadence_editable
    }
  }
`;

/**
 * Delivery channels come from the server so new ones appear without a
 * frontend change.
 */
export const GET_NOTIFICATION_CHANNELS = gql`
  query getNotificationChannels {
    getNotificationChannels {
      id
      key
      title
    }
  }
`;

export const GET_NOTIFICATION_CADENCES = gql`
  query getNotificationCadences {
    getNotificationCadences {
      id
      key
      title
    }
  }
`;

export const UPSERT_COMPANY_NOTIFICATION_PREFERENCE = gql`
  mutation upsertCompanyNotificationPreference(
    $input: CompanyNotificationPreferenceInput!
  ) {
    upsertCompanyNotificationPreference(input: $input) {
      success
      message
    }
  }
`;

export const UPSERT_MY_NOTIFICATION_PREFERENCE = gql`
  mutation upsertMyNotificationPreference(
    $input: MyNotificationPreferenceInput!
  ) {
    upsertMyNotificationPreference(input: $input) {
      success
      message
    }
  }
`;
